var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-navigation',{attrs:{"value":true,"app":"","shift":!_vm.bigEnough,"grow":""}},_vm._l((_vm.navs),function(nav){return _c('Bottomicons',{key:nav.value,attrs:{"nav":nav}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }